import React from 'react'
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import Assignment from '../components/assignment/Assignment';
import AssignmentForm from '../components/assignment/AssignmentForm';
import Error from '../components/ui/Error';
import Loader from '../components/ui/Loader';
import Navbar from '../components/ui/Navbar'
import { useGetAssignmentsQuery } from '../features/assignments/assignmentsApi';
import { toggleAssignmentModal } from '../features/assignments/assignmentsSlice';

function Assigments() {
	//States
	const { isAssignmentModalOpen } = useSelector((state) => state.assignments);
	const { data: assignments, isLoading, isError } = useGetAssignmentsQuery() || {};
	const dispatch = useDispatch();

	//Functions
	const handleModal = () => {
		dispatch(toggleAssignmentModal(!isAssignmentModalOpen))
	}


	//Decide what to render
	let content = null;

	if (isLoading) {
		content = <Loader />
	}
	if (!isLoading && isError) {
		content = <Error message="There was an error occured!" />
	}
	if (!isLoading && !isError && assignments.length === 0) {
		content = <div className='text-center'>No Assignments Found</div>
	}
	if (!isLoading && !isError && assignments.length > 0) {
		content = (
			<div className="overflow-x-auto mt-4">
				<table className="divide-y-1 text-base divide-gray-600 w-full">
					<thead>
						<tr>
							<th className="table-th">Title</th>
							<th className="table-th">Video Title</th>
							<th className="table-th">Mark</th>
							<th className="table-th">Action</th>
						</tr>
					</thead>

					<tbody className="divide-y divide-slate-600/50">
						{assignments.map((assignment) => (<Assignment key={assignment.id} assignment={assignment} />))}
					</tbody>
				</table>
			</div>
		);
	}

	return (
		<>
			<Helmet>
				<title>Assignments</title>
			</Helmet>
			<Navbar />
			<section className="py-6 bg-primary">
				<div className="mx-auto max-w-full px-5 lg:px-20">
					<div className="px-3 py-20 bg-opacity-10">
						<div className="w-full flex">
							<button className="btn ml-auto" onClick={handleModal}>Add Assignment</button>
						</div>
						{content}
					</div>
				</div>
			</section>
			{isAssignmentModalOpen && <AssignmentForm />}
		</>
	)
}

export default Assigments